import { inject } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';

export const authGuard = () => {
  const authService = inject(AuthService);
  const state = inject(Router)?.routerState?.snapshot;

  return authService.canActivateProtectedRoutes$.pipe(
    tap((x) => console.log('You tried to go to ' + state?.url + ' and this guard said ' + x))
  );
};
